module.exports = __webpack_public_path__ + "static/media/logo-7.64a4525d.jpg";